import { fastComponent } from "../../../utils/fastHooks.js";
import { useRenderDialogRoot } from "./useRenderDialogRoot.js";
const DialogRoot = fastComponent(function DialogRoot2(props) {
  return useRenderDialogRoot("dialog", props);
});
if (process.env.NODE_ENV !== "production") DialogRoot.displayName = "DialogRoot";
export {
  DialogRoot
};
//# sourceMappingURL=DialogRoot.js.map
